export default "__VITE_ASSET__CWJ38lJc__"